/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOLeaveApplied from "./DTOActiveLoans";
import ActiveLoansPresenter from "./ActiveLoansPresenter";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function ActiveLoansController() {
  const { t } = useTranslation();
  const currency = useAppSelector((state) => state.authSlice.currency);
  const [allLoansData, setAllLoansData] = useState([]);

  const isLoading = useAppSelector(
    (state) => state.activeLoansSlice.activeLoanLoader
  );
  const pendingLoans = useAppSelector(
    (state) => state.activeLoansSlice.activeLoans
  );

  function callBackFunc(data: any) {
    setAllLoansData(data);
  }

  return (
    <>
      <DTOLeaveApplied setLoansAppliedData={callBackFunc} />
      <ActiveLoansPresenter
        loansData={allLoansData}
        currency={currency}
        isLoading={isLoading}
        pendingLoans={pendingLoans}
        trans={t}
      />
    </>
  );
}

export default ActiveLoansController;
